export default __webpack_public_path__ + "static/media/no_activity.bcdb9f8d.svg";